function setContent(state = [], action) {
  if (action.type === 'SET_CONTENT') {
    return action.content
  }
  return state;
}

function clearContent(state = [], action) {
  if (action.type === 'CLEAR_CONTENT') {
    return {}
  }
  return state;
}

function content(state = [], action) {
  if (!!action.content) {
    if (Object.keys(action.content).length) {
      return setContent(state, action);
    } else {
      return clearContent(state, action);
    }
  }
  return state;
}
export default content;


// WEBPACK FOOTER //
// ./src/reducers/content.js